export default __webpack_public_path__ + "5e35a7005b6d725a8b8f08181e210402.png";